module.exports = __webpack_public_path__ + "static-portal/img/xzz-jbgl.a66ee9d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/xzz-jbgl.jpg
// module id = pf/H
// module chunks = 4